export const faqRoutePathConst ={
    CategoryTablePage:"CATEGORY TABLE",
   FaqListTablePage:"FAQ TABLE",
   CategoryDeleteFormList:"Category Delete form setting icon"
}
